import { render } from "./UsuarioDados.vue?vue&type=template&id=2be8c0b3&scoped=true"
import script from "./UsuarioDados.vue?vue&type=script&lang=js"
export * from "./UsuarioDados.vue?vue&type=script&lang=js"

import "./UsuarioDados.vue?vue&type=style&index=0&id=2be8c0b3&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2be8c0b3"]])

export default __exports__